// Official-email rule (owner, 2026-10-01): only @almikia.com addresses can create an account.
// The database enforces it for every API-side write to auth.users (enforce_official_email());
// this helper only gives the forms an early, clear message.
export const OFFICIAL_EMAIL_DOMAIN = "almikia.com";

const OFFICIAL_EMAIL_PATTERN = /^[^@\s]+@almikia\.com$/i;

export const isOfficialEmail = (value: unknown): boolean =>
  typeof value === "string" && OFFICIAL_EMAIL_PATTERN.test(value.trim());

// ra-core validator: an empty value is left to required(); anything else must be official.
export const officialEmail =
  (message = "crm.auth.official_email_required") =>
  (value: unknown) =>
    value == null || value === "" || isOfficialEmail(value)
      ? undefined
      : { message, args: {} };
